export const LABRESULT_LIST_REQUEST = 'LABRESULT_LIST_REQUEST';
export const LABRESULT_LIST_SUCCESS = 'LABRESULT_LIST_SUCCESS';
export const LABRESULT_LIST_FAIL = 'LABRESULT_LIST_FAIL';

export const LABRESULT_DETAILS_REQUEST = 'LABRESULT_DETAILS_REQUEST';
export const LABRESULT_DETAILS_SUCCESS = 'LABRESULT_DETAILS_SUCCESS';
export const LABRESULT_DETAILS_FAIL = 'LABRESULT_DETAILS_FAIL';
export const LABRESULT_DETAILS_RESET = 'LABRESULT_DETAILS_RESET';

export const LABRESULT_CREATE_REQUEST = 'LABRESULT_CREATE_REQUEST';
export const LABRESULT_CREATE_SUCCESS = 'LABRESULT_CREATE_SUCCESS';
export const LABRESULT_CREATE_FAIL = 'LABRESULT_CREATE_FAIL';
export const LABRESULT_CREATE_RESET = 'LABRESULT_CREATE_RESET';

export const LABRESULT_UPDATE_REQUEST = 'LABRESULT_UPDATE_REQUEST';
export const LABRESULT_UPDATE_SUCCESS = 'LABRESULT_UPDATE_SUCCESS';
export const LABRESULT_UPDATE_FAIL = 'LABRESULT_UPDATE_FAIL';
export const LABRESULT_UPDATE_RESET = 'LABRESULT_UPDATE_RESET';

export const LABRESULT_DELETE_REQUEST = 'LABRESULT_DELETE_REQUEST';
export const LABRESULT_DELETE_SUCCESS = 'LABRESULT_DELETE_SUCCESS';
export const LABRESULT_DELETE_FAIL = 'LABRESULT_DELETE_FAIL';

export const LABRESULT_DTO_REQUEST = 'LABRESULT_DTO_REQUEST';
export const LABRESULT_DTO_SUCCESS = 'LABRESULT_DTO_SUCCESS';
export const LABRESULT_DTO_FAIL = 'LABRESULT_DTO_FAIL';
export const LABRESULT_DTO_RESET = 'LABRESULT_DTO_RESET';

export const LABRESULT_LIST_BY_IDS_REQUEST = 'LABRESULT_LIST_BY_IDS_REQUEST';
export const LABRESULT_LIST_BY_IDS_SUCCESS = 'LABRESULT_LIST_BY_IDS_SUCCESS';
export const LABRESULT_LIST_BY_IDS_FAIL = 'LABRESULT_LIST_BY_IDS_FAIL';
export const LABRESULT_LIST_BY_IDS_RESET = 'LABRESULT_LIST_BY_IDS_RESET'; 